import { makeStyles, Theme } from '@material-ui/core/styles';
import { red, pink, orange } from '@material-ui/core/colors';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    noBorder: {
      border: 'none',
    },
    value: {
      fontSize: 34,
      marginBottom: theme.spacing(1),
    },
    yesValue: {
      fontSize: 20,
    },
    title: {
      flexGrow: 1,
      maxWidth: 280,
      //height: 60,
      fontSize: 16,
      marginBottom: theme.spacing(3),
      color: '#757575',
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    gridPaper: {
      height: '140px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      padding: '16px',
      boxSizing: 'border-box',
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    infoContainer: {
      display: 'flex',
      marginBottom: theme.spacing(1),
      alignItems: 'stretch',
    },
    link: {
      display: 'inline-block',
      textTransform: 'uppercase',
      color: theme.palette.info.main,
      letterSpacing: 0.4,
      fontSize: 14,
      //marginLeft: theme.spacing(1),
      //fontWeight: 600,
      margin: `0 ${theme.spacing(3)}px 0 0`,
    },
    dataGrid: {
      width: '100%',
      '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
      '& .MuiDataGrid-root .MuiDataGrid-row': {
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .row-background-error': {
        backgroundColor: red[50],
        '&:hover': {
          backgroundColor: red[100],
        },
      },
      '& .row-background-alert': {
        backgroundColor: pink[50],
        '&:hover': {
          backgroundColor: pink[100],
        },
      },
      '& .row-background-transaction': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .cell-text-color-error': {
        color: pink[700],
      },
      '& .cell-text-color-alert': {
        color: orange[700],
      },
      '& .cell-text-color-transaction': {
        color: 'black',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      '& .MuiDataGrid-colCellTitle': {
        color: 'black',
        fontWeight: '700',
        textTransform: 'capitalize',
      },
    },
    tooltip: {
      width: '75px',
      height: '25px',
      fontSize: '10px',
      lineHeight: 'auto',
      text: 'center',
    },
  }),
  {
    index: 1,
  }
);
